import Icon from 'react-icon-base';

const IcAccount = props => (
   <Icon viewBox='0 0 108.24 108.24' {...props}>
      <g stroke-width='1.97px' fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round'>
         <circle className='cls-2' cx='54.12' cy='54.12' r='52.62' />
         <g stroke-width='3px'>
            <path
               className='cls-2'
               d='M41.29,20.26c-9.16,0-16.59,7.43-16.59,16.59,0,4.37,1.61,8.25,4.37,11.22h0s0,2.07-3.89,4.56c0,0,2.19,2.08,7.75-1.45h0c2.48,1.47,5.27,2.26,8.37,2.26,9.16,0,16.59-7.43,16.59-16.59s-7.43-16.59-16.59-16.59Z'
            />
            <path
               className='cls-2'
               d='M29.17,58.41s2.52-.24,4.87-1.46c0,0,8.93,4.38,18.18-.73,0,0,7.63-3.89,9.82-13.39,0,0,.16-4.54,8.44-5.52,0,0,1.95.32.81,2.68-1.14,2.35-1.62,3.98-.97,6.33,0,0,5.27,3.81,7.06,9.9,0,0,4.3-.97,4.46,3.16v5.72s.44,2.69-4.32,2.69c0,0-1.43,5.34-6.2,9.45,0,0-3.4,2.2-3.4,6.05,0,0,.79,3.85-1.29,3.85h-9.2s-.79.23-.79-3.46c0,0-5.14,1.52-6.84-.18v2.65s-.04.99-1.83.99-7.99,0-7.99,0c0,0-1.65.23-1.65-2.32s-1.68-6.3-3.22-7.48c-1.54-1.18-7.84-9.31-5.94-18.95Z'
            />
            <circle className='cls-2' cx='68.84' cy='54.25' r='1.94' />
         </g>
         <g>
            <path
               className='cls-1'
               d='M45.46,44.24c-.75.26-1.56.4-2.41.4-4.05,0-7.33-3.28-7.33-7.33s3.28-7.33,7.33-7.33c.86,0,1.68.15,2.44.42'
            />
            <g>
               <line className='cls-1' x1='33.68' y1='36.07' x2='42.3' y2='36.07' />
               <line className='cls-1' x1='33.66' y1='38.56' x2='40.93' y2='38.56' />
            </g>
         </g>
      </g>
   </Icon>
);

export default IcAccount;
